<template>
  <form @submit.prevent="getList()" method="GET" novalidate>
    <div class="card-body">
      <div class="form-row">
        <div class="col-md-6">
          <div class="form-group from-row">
            <label class="col-md-3 col-form-label" for="bundle_id"
              >Bundle Id</label
            >
            <div class="col-md-9">
              <input
                type="text"
                id="bundle_id"
                class="form-control"
                v-model="search.bundle_id"
                placeholder="Bundle Id"
              />
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group from-row">
            <label class="col-md-3 col-form-label" for="bundle_title">Bundle title</label>
            <div class="col-md-9">
              <input
                type="text"
                id="bundle_title"
                class="form-control"
                v-model="search.bundle_title"
                placeholder="bundle_title"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-9">
              <button type="submit" class="btn btn-common m-2px">
                <i class="fas fa-search"></i> Search
              </button>
              <button
                type="reset"
                class="btn btn-warning"
                @click="resetFilter()"
              >
                <i class="fas fa-undo"></i> Reset
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
export default {
  props: ["filter"],
  data: () => ({
    search: {},
  }),
  mounted() {
    this.search = this.filter;
  },
  methods: {
    resetFilter() {
      // this.search = {};
      this.$router.push({ path: this.$route.path }).catch(() => {});
    },
    async getList() {
      this.$router
        .push({
          path: this.$route.fullPath,
          query: this.search,
        })
        .catch((e) => {});
    },
  },
};
</script>
